import { PageMeta } from 'constants/pages';
import { ArticleSections } from 'types/articles';

import {
  firstSeptember2025NewsData,
  firstSeptember2025NewsMeta,
} from '../news/first-september-2025-news';
import { aiSummitTurku2025NewsData, aiSummitTurku2025NewsMeta } from '../news/ai-summit-turku-2025-news';
import { waveSensePartnership, waveSensePartnershipMeta } from '../partnership/wave-sense';
import { amdSiloPartnership, amdSiloPartnershipMeta } from '../partnership/amd-silo';

interface CompanyUpdateParameters {
  pageMeta: PageMeta;
  articleData: ArticleSections[];
}

export const COMPANY_UPDATES: CompanyUpdateParameters[] = [
  {
    pageMeta: firstSeptember2025NewsMeta,
    articleData: firstSeptember2025NewsData,
  },
  {
    pageMeta: aiSummitTurku2025NewsMeta,
    articleData: aiSummitTurku2025NewsData,
  },
  {
    pageMeta: waveSensePartnershipMeta,
    articleData: waveSensePartnership,
  },
  {
    pageMeta: amdSiloPartnershipMeta,
    articleData: amdSiloPartnership,
  },
];
